import React, { Dispatch, SetStateAction } from "react"
import useT from "utils/useT"
import { motion } from "framer-motion"

type Props = {
  setSuccess: Dispatch<SetStateAction<boolean>>
}

const SuccessCard = ({ setSuccess }: Props) => {
  const t = useT()

  return (
    <>
      <motion.div layoutId="contact-form" className="card card-style">
        <div className="shadow-l rounded-m gradient-green me-n1 ms-n1 mb-n1 ">
          <motion.h1
            initial={{
              opacity: 0,
            }}
            animate={{
              opacity: 1,
              transition: {
                delay: 0.5,
                duration: 0.5,
                ease: "easeInOut",
              },
            }}
            className="color-white text-center pt-4"
          >
            <i className="fa fa-check-circle fa-3x shadow-s scale-box rounded-circle"></i>
          </motion.h1>
          <motion.h2
            initial={{
              opacity: 0,
            }}
            animate={{
              opacity: 1,
              transition: {
                delay: 0.5,
                duration: 0.5,
                ease: "easeInOut",
              },
            }}
            className="color-white bold text-center pt-3"
          >
            {t.contact.messageSent}
          </motion.h2>
          <motion.p
            initial={{
              opacity: 0,
            }}
            animate={{
              opacity: 1,
              transition: {
                delay: 0.5,
                duration: 0.5,
                ease: "easeInOut",
              },
            }}
            className="color-white p-4 text-center mt-n2 mb-0"
          >
            {t.contact.thankYou}
          </motion.p>
        </div>
      </motion.div>
      <div className="px-3 mb-5">
        <motion.button
          initial={{
            opacity: 0,
          }}
          animate={{
            opacity: 1,
            transition: {
              duration: 0.5,
              ease: "easeInOut",
            },
          }}
          onClick={() => setSuccess((prevState: boolean) => !prevState)}
          className="btn bg-highlight text-uppercase font-900 btn-m btn-full rounded-sm  shadow-xl w-100"
        >
          send another message
        </motion.button>
      </div>
    </>
  )
}

export default SuccessCard
